import QBPPresentation from './QBPPresentation'

const abundanceEngineExports = {
  QBPPresentation
}

export default abundanceEngineExports
